import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import {
	addObjective,
	addWorkShift,
	deleteObjective,
	deleteWorkShift,
	editObjective,
	editWorkShift,
	getAbsenceList,
	getStandsListAPI,
	getUniqueVisit,
	getVisits,
	getWorkShift,
	getWorkShiftSalesPerson,
	updateVisit
} from '../apis/trackingAPIs';
import { showSuccessToast } from '../../app/utils/tostify';

interface TrackingState {
	loading: boolean;
	error: string;
	appSetting: any;
	workShiftData: any;
	visitAction: any;
	visitPhoto: any;
	standPhoto: any;
	standList: any;
	standLog: any;
	workShiftSettings: any;
	count: number;
	visitCount: number;
	currentPage: number;
	filter: any;
	salesPersonList: any;
}
const initialState: TrackingState = {
	loading: false,
	error: '',
	appSetting: null,
	visitPhoto: false,
	visitAction: false,
	standList: [],
	standPhoto: false,
	standLog: 0,
	workShiftSettings: null,
	workShiftData: [],
	count: 0,
	currentPage: 1,
	visitCount: 0,
	salesPersonList: [],
	filter: null
};
const trackingSlice = createSlice({
	name: 'tracking',
	initialState,
	reducers: {
		resetShiftData(state) {
			state.workShiftData = [];
		},
		handleFilter(state, action: any) {
			state.filter = action.payload;
		},
		handlePagination(state, action: any) {
			state.currentPage = action.payload;
		},
		// tempOTP(state, action: any) {
		// 	state.tempOTP = action.payload;
		// },
	},
	extraReducers: builder => {
		builder.addCase(addWorkShift.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(addWorkShift.fulfilled, (state: TrackingState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(addWorkShift.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(editWorkShift.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(editWorkShift.fulfilled, (state: TrackingState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(editWorkShift.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getWorkShift.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getWorkShift.fulfilled, (state: TrackingState, action: any) => {
			state.loading = false;
			state.workShiftData = action.payload.data?.list;
			state.count = action?.payload?.data?.count;
			state.workShiftSettings = null;
		});
		builder.addCase(getWorkShift.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(deleteWorkShift.pending, (state: TrackingState) => {
			state.loading = true;
		});
		builder.addCase(deleteWorkShift.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			showSuccessToast({ message: t(action.payload.message) });
		});
		builder.addCase(deleteWorkShift.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getWorkShiftSalesPerson.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getWorkShiftSalesPerson.fulfilled,
			(state: TrackingState, action: any) => {
				state.loading = false;
				state.salesPersonList = action.payload.data;
			}
		);
		builder.addCase(getWorkShiftSalesPerson.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(addObjective.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(addObjective.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(addObjective.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(editObjective.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(editObjective.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(editObjective.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getVisits.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getVisits.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			state.workShiftData = action.payload.data?.objectives;
			state.visitAction = action.payload.data?.require_next_action;
			state.visitPhoto = action.payload.data?.require_visit_photo;
			state.standPhoto = action.payload.data?.require_stand_photo;
			state.standLog = action.payload.data?.stand_log_duration;
		});
		builder.addCase(getVisits.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(deleteObjective.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(deleteObjective.fulfilled, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(deleteObjective.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(updateVisit.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateVisit.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(updateVisit.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getUniqueVisit.pending, (state: TrackingState) => {
			// state.loading = true;
			state.error = '';
		});
		builder.addCase(getUniqueVisit.fulfilled, (state: TrackingState, action) => {
			state.loading = false;
			state.visitCount = action?.payload?.data?.count;
		});
		builder.addCase(getUniqueVisit.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getStandsListAPI.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getStandsListAPI.fulfilled,
			(state: TrackingState, action: any) => {
				state.loading = false;
				state.standList = action.payload.data?.list || [];
			}
		);
		builder.addCase(getStandsListAPI.rejected, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getAbsenceList.pending, (state: TrackingState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getAbsenceList.fulfilled, (state: TrackingState) => {
			state.loading = false;
		});
		builder.addCase(getAbsenceList.rejected, (state: TrackingState) => {
			state.loading = false;
		});
	}
});
export const { resetShiftData, handleFilter, handlePagination } = trackingSlice.actions;
export default trackingSlice.reducer;